export const curriculumData = [
    {
        type: 'Experience',
        id: 'leadthefuture',
        title: 'Lead The Future Mentorship',
        subtitle: 'Mentee',
        date: 'Sep 2026 - Present',
        location: 'Amsterdam, NL',
        coords: { lat: 52.3558, lng: 4.9555 }, // Science Park UvA
        tags: ['Mentorship', 'Leadership', 'STEM', 'Networking'],
        description: [
            'Among the few **Italian students** selected as mentees for **LeadTheFuture**, a leading mentorship non-profit for students in STEM, with an **acceptance rate below 20%**.',
            'Receiving **one-on-one guidance** from high-impact mentors from the world\'s leading STEM innovation hubs, such as **Silicon Valley** and **CERN**.'
        ]
    },
    {
        type: 'Workshop',
        id: 'wmbooth-26',
        title: 'Mind the Gap: Promises and Pitfalls of Hierarchical Planning in LeWorldModel',
        subtitle: 'Accepted and Presented at WM@Booth 2026',
        date: 'Sep 2026',
        location: 'Chicago, IL',
        coords: { lat: 41.8500, lng: -87.6500 },
        tags: ['Hierarchical Planning', 'World Models', 'Reinforcement Learning', 'Diagnostic Analysis'],
        description: [
            'Presented a **diagnostic evaluation** of hierarchical planning within the LeWorldModel framework, identifying critical bottlenecks in temporal abstraction.',
            'Analyzed the trade-offs of multi-level decision making, focusing on **compounding model errors** and planning efficiency across long horizons.',
            'Proposed **mitigation strategies and open directions** to improve value estimation and stability in hierarchical world models.'
        ]
    },
    {
        type: 'Workshop',
        id: 'darliap-26',
        title: 'From Human to Scalable Annotation: Teaching LLMs to mimic experts labeling on Economic News Sentiment',
        subtitle: 'Presented at DARLI-AP 2026',
        date: 'Mar 2026',
        location: 'Tampere, FI',
        coords: { lat: 61.4978, lng: 23.7610 },
        tags: ['Sentiment Analysis', 'Economics', 'News', 'LLM'],
        description: [
            'Presented work on a **human-annotated Italian economic news corpus** and a **LoRA-adapted instruction-tuned model** aligned with expert annotations.',
            'Compared **long-context and instruction-tuned models** for mimicking expert sentiment labeling at scale.'
        ]
    },
    {
        type: 'Award',
        id: 'ing-hackathon',
        title: 'First place ING\'s Global Hackathon 2026 - Student Track',
        subtitle: 'Hosted by ING',
        date: 'Feb 2026',
        location: 'Amsterdam, NL',
        coords: { lat: 52.3558, lng: 4.9555 },
        tags: ['Artificial Intelligence', 'Data Analysis', 'LLMs', 'Hackathon'],
        description: [
            'Developed an **AI-powered ESG risk assessment platform** for automated extraction and analysis of sustainability data from corporate reports.',
            'Implemented a **full-stack solution** (FastAPI + React) with **LLM-based vision and text processing** to extract emissions metrics, targets, and assurance data from complex PDFs.',
            'Enabled ESG trend analysis and risk-based decision support for financial institutions, with evaluation of **multiple document extraction approaches**.'
        ]
    },
    {
        type: 'Award',
        id: 'prosus-hackathon',
        title: 'Selected participant Prosus AI Hackathon 2025',
        subtitle: 'Hosted by Prosus',
        date: 'Nov 2025',
        location: 'Amsterdam, NL',
        coords: { lat: 52.3558, lng: 4.9555 }, // Science Park UvA
        tags: ['Artificial Intelligence', 'Agentic AI', 'Hackathon'],
        description: [
            'Selected participant in the Prosus AI Hackathon 2025, a competition where teams develop innovative solutions using **agentic AI**.',
            'We were **100 participants** with more than **400 applicants** across all the Netherlands'
        ]
    },
    {
        type: 'Education',
        id: 'ms-uva',
        title: 'MS University of Amsterdam (UvA)',
        subtitle: 'Artificial Intelligence',
        date: 'Sep 2025 - Aug 2027',
        location: 'Amsterdam, NL',
        coords: { lat: 52.3558, lng: 4.9555 }, // Science Park UvA
        tags: ['Machine Learning', 'Deep Learning', 'Computer Vision', 'Natural Language Processing', 'Information Retrieval'],
        description: [
            '**Research-oriented** curriculum focusing on the theoretical foundations and end-to-end development of state-of-the-art AI models.',
            '**Practical application** through intensive laboratory projects and the regular presentation of complex architectural and research findings.',
            '**GPA**: 8.45/10'
        ]
    },
    {
        type: 'Experience',
        id: 'smartdata',
        title: 'SmartData@Polito',
        subtitle: 'Undergraduate Researcher',
        date: 'Nov 2024 - Jun 2025',
        location: 'Turin, IT',
        coords: { lat: 45.0621, lng: 7.6625 }, // Polito
        tags: ['RAG', 'LLMs', 'Data Visualization', 'Data Analysis', 'Research', 'Python'],
        description: [
            'Design and development of an application featuring **RAGs** and **LLMs** to enhance the value of public **real estate assets**.',
            'Development of an AI methodology for analyzing **inflation dynamics** by integrating exogenous and endogenous quantitative data, news sources and domain knowledge.',
            'Abstract accepted for **HiTEc & CoDES 2025**'
        ]
    },
    {
        type: 'Award',
        id: 'best-hackathon',
        title: 'First place BEST Hackathon 2024',
        subtitle: 'Hosted by Reale Group',
        date: 'Apr 2024',
        location: 'Turin, IT',
        coords: { lat: 45.0621, lng: 7.6625 }, // Polito
        tags: ['Insurance', 'Semi-autonomous vehicles', 'Public Speaking'],
        description: [
            'Led a university team to design a **case study** for **premium calculations** in insurance. Achieved first place among 39 teams.'
        ]
    },
    {
        type: 'Experience',
        id: 'politocean',
        title: 'PoliTOcean student team',
        subtitle: 'Software Developer',
        date: 'Mar 2024 - Jul 2025',
        location: 'Turin, IT',
        coords: { lat: 45.0621, lng: 7.6625 }, // Polito
        tags: ['ROS2', 'PyQt6', 'C++', 'Robotics', 'Path Planning', 'Sensors', 'GUI Development'],
        description: [
            'Design and development of a **Graphical User Interface** for real-time monitoring and control of the **ROV**.',
            'Developed nodes for **handling communication** and **acquiring data** from sensors, crucial for navigation stability and monitoring.',
            'Started transitioning from **ROV** to **AUV** by sketching the architecture, integrating additional sensors and implementing **path planning algorithms**.'
        ]
    },
    {
        type: 'Experience',
        id: 'ieee',
        title: 'Mu Nu Chapter, IEEE-HKN',
        subtitle: 'Vice coordinator - Corporate Training area',
        date: 'Oct 2024 - Jul 2025',
        location: 'Turin, IT',
        coords: { lat: 45.0621, lng: 7.6625 }, // Polito
        tags: ['Public Speaking', 'Leadership', 'Networking', 'Event Organization', 'Communication'],
        description: [
            'Contacted and **organized meetings** with industry experts in IEEE-related fields.',
            'Presented and moderated presentations for associate members.'
        ]
    },
    {
        type: 'Award',
        id: 'ibec',
        title: 'Second place IBEC BEST 2024',
        subtitle: 'Hosted by Reply',
        date: 'Nov 2023',
        location: 'Turin, IT',
        coords: { lat: 45.0621, lng: 7.6625 }, // Polito
        tags: ['Generative AI', 'Architecture', 'Design', 'Case Study'],
        description: [
            'Achieved second place for creating a **case study** to improve the **work of architects and designers**.'
        ]
    },
    {
        type: 'Award',
        id: 'intraprendenti',
        title: 'Intraprendenti Program',
        subtitle: 'Polytechnic University of Turin',
        date: 'Sep 2023 - Sep 2025',
        location: 'Turin, IT',
        coords: { lat: 45.0621, lng: 7.6625 }, // Polito
        tags: ['Problem Solving', 'Soft Skills', 'Multidisciplinary', 'Innovation'],
        description: [
            'Prestigious program aimed at **enhancing professional skills**.',
            'Enrolled as one of the top **200 engineering** and **40 architecture students**, with access to scholarships and immersive, multidisciplinary coursework.'
        ]
    },
    {
        type: 'Education',
        id: 'bs-polito',
        title: 'BS Polytechnic University of Turin',
        subtitle: 'Computer Engineering',
        date: 'Sep 2022 - Sep 2025',
        location: 'Turin, IT',
        coords: { lat: 45.0621, lng: 7.6625 }, // Polito
        tags: ['Computer Architecture', 'Algorithms', 'Data Structures', 'Databases', 'Operating Systems', 'OOP'],
        description: [
            '110/110 cum laude',
            '**Activities and societies:** PoliTOcean, Mu Nu Chapter - IEEE-HKN, SmartData@Polito, Intraprendenti Program'
        ]
    },
    {
        type: 'Education',
        id: 'dubai2022',
        title: 'Estate Inpsieme - Dubai 2022',
        subtitle: 'Italian Summer Study Program',
        date: 'Jul 2022 - Aug 2022',
        location: 'Dubai, UAE',
        coords: { lat: 25.0657, lng: 55.1713 }, // Dubai
        tags: ['English', 'Cultural Exchange'],
        description: [
            'Attended a **15-day academic program**, focusing on daily classroom study in English.',
            'Explored **Dubai** through guided cultural and educational excursions in the afternoons.',
            'Lived in a college with Italian and International students.'
        ]
    },
    {
        type: 'Education',
        id: 'madrid2021',
        title: 'Estate Inpsieme - Madrid 2021',
        subtitle: 'Italian Summer Study Program',
        date: 'Jul 2021 - Jul 2021',
        location: 'Madrid, ES',
        coords: { lat: 40.47, lng: -3.56 }, // Madrid
        tags: ['English', 'Cultural Exchange'],
        description: [
            'Attended a **15-day academic program**, focusing on daily classroom study in English.',
            'Explored **Madrid** through guided cultural and educational excursions in the afternoons.',
            'Lived in a college with Italian and International students.'
        ]
    },
    {
        type: 'Education',
        id: 'london2018',
        title: 'Estate Inpsieme - London 2018',
        subtitle: 'Italian Summer Study Program',
        date: 'Jun 2018 - Jul 2018',
        location: 'London, UK',
        coords: { lat: 51.5085, lng: 0.1257 }, // London
        tags: ['English', 'Cultural Exchange'],
        description: [
            'Attended a **15-day academic program**, focusing on daily classroom study in English.',
            'Explored **London** through guided cultural and educational excursions in the afternoons.',
            'Lived in a college with Italian and International students.'
        ]
    },
    {
        type: 'Education',
        id: 'high-school',
        title: 'High School',
        subtitle: 'Liceo Scientifico Scienze Applicate - Leonardo da Vinci',
        date: '2017 - 2022',
        location: 'Agrigento, IT',
        coords: { lat: 37.3029, lng: 13.5987 }, // Agrigento
        tags: ['Physics', 'Chemistry', 'Mathematics', 'Computer Science', 'Arduino', 'C++', 'Robotics'],
        description: [
            '100/100 cum laude',
            'First experiences with **3D printing**, **robotics**, and **Arduino**',
            '**National Pathway “Biologia con curvatura biomedica”**: After-school program offering advanced biology and biomedical training, supported by professional guidance, to enhance students\' scientific preparation beyond the standard curriculum.'
        ]
    },
    {
        type: 'Childhood',
        id: 'childhood',
        title: 'Hometown',
        subtitle: 'Racalmuto, Italy',
        date: '2003 - 2022',
        location: 'Racalmuto, IT',
        coords: { lat: 37.4088, lng: 13.7326 }, // Racalmuto
        tags: ['3D modeling', 'Frontend', 'Programming', 'Photography', 'Video editing'],
        description: [
            '**Experienced** with various **softwares** and **programming languages**, including Blender, HTML, CSS, JavaScript, C, Photoshop, DaVinci Resolve'
        ]
    }
];
